<template>
    <div v-if="isOpen" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div class="bg-gray-800 p-6 rounded-lg shadow-lg w-96">
        <h2 class="text-lg font-semibold mb-4">{{ title }}</h2>
        <p class="mb-4">{{ message }}</p>
        <div class="flex justify-end space-x-3">
          <button @click="cancel" class="bg-gray-500 px-4 py-2 rounded hover:bg-gray-600">Cancel</button>
          <button @click="confirm" class="bg-red-500 px-4 py-2 rounded hover:bg-red-600">Confirm</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "ConfirmModal",
    props: {
      isOpen: Boolean,
      title: String,
      message: String
    },
    emits: ["confirm", "cancel"],
    methods: {
      confirm() {
        this.$emit("confirm");
      },
      cancel() {
        this.$emit("cancel");
      }
    }
  };
  </script>
  